
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function DiabeticFoot(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Diabetic foot"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>Diabetic foot is one of the most significant and devastating complications of diabetes, and is defined as<b>  a foot affected by ulceration that is associated with neuropathy and/or peripheral arterial disease of the lower limb</b> in a patient with diabetes.</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Diabetic-foot/1.png")} alt="Diabetic-foot" />
                                    </div>
                                </div>
                                <br></br>
                                <p>A <b> diabetic foot </b> is any pathology that results directly from <a className='links' href='https://en.wikipedia.org/wiki/Peripheral_artery_disease'>peripheral
                                    arterial disease</a> (PAD) and/or sensory neuropathy affecting the feet in <a className='links' href='https://en.wikipedia.org/wiki/Diabetes'>diabetes mellitus</a>; it is a long-term (or "chronic") <a className='links' href='https://en.wikipedia.org/wiki/Complications_of_diabetes'>complication of
                                        diabetes mellitus.</a> Presence of several characteristic diabetic foot
                                    pathologies such as <a className='links' href='https://en.wikipedia.org/wiki/Infection'>infection, diabetic foot ulcer</a> and <a className='links' href='https://en.wikipedia.org/wiki/Neuropathic_arthropathy'>neuropathic osteoarthropathy</a> is called <b> diabetic foot syndrome.</b></p>
                                <p><b>Signs of Diabetic Foot Problems</b></p>
                                <p>Changes in skin colour.</p>
                                <p>Changes in skin temperature.</p>
                                <p>Swelling in the foot or ankle.</p>
                                <p>Pain in the legs.</p>
                                <p>Open sores on the feet that are slow to heal or are draining.</p>
                                <p>Ingrown toenails or toenails infected with fungus.</p>
                                <p>Corns or calluses.</p>
                                <p>Dry cracks in the skin, especially around the heel.</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Diabetic_foot">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default DiabeticFoot;